import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn } from "@angular/router";
import { IGroupDto, IUserDto } from "moo-shared";
import { IAuthApiGroupDto } from "../../core/authentication/authentication-api.service";
import { IIpOrganisationDto } from "../../core/authentication/ip-organisation.dto";
import { LoginAssistantService } from "./login-assistant.service";

//old style resovlers are deprecated since angular16 so made the functional resolver
// test for this funcationality will be done in scope of Task 24759: add testes for login assistant resovlers
//currently too much time spent and didn't find a way to make it work, not even with oficial docuemntaion of ng-mocks
export const loginAssistantOrganisationResolver: ResolveFn<IIpOrganisationDto> = () => {
  return inject(LoginAssistantService).getSelectedOrganisation();
};

export const loginAssistantGroupsResolver: ResolveFn<IGroupDto[]> = () => {
  return inject(LoginAssistantService).getOrganizationGroups();
};

export const authApiGroupsResolver: ResolveFn<IAuthApiGroupDto[]> = () => {
  return inject(LoginAssistantService).getAuthApiOrganizationGroups();
};

export const groupUsersResolver: ResolveFn<IUserDto[]> = (route: ActivatedRouteSnapshot) => {
  return inject(LoginAssistantService).getGroupStudents(route);
};
